const ASIN_REGEX = /^(?:[A-Z][A-Z0-9]{9}|[0-9]{9}[0-9X])$/;
const TOTE_SCANNABLE_ID_REGEX = /^[A-Za-z0-9%_-]+$/;

export function normalizeAsin(asin: string): string {
  return asin.trim().toUpperCase();
}

export function isValidAsin(asin: string): boolean {
  return ASIN_REGEX.test(asin);
}

export function isValidToteScannableId(scannableId: string): boolean {
  return TOTE_SCANNABLE_ID_REGEX.test(scannableId);
}
